import './SearchChips.scss';

import { Chip, Divider, Tooltip } from '@trackman/web-shared-components';

import { DateRangeDto } from 'types/CodegenReportTypes';
import { useTranslation } from 'react-i18next';
import { displayDate } from 'utilities/dateHelpers';

type Props = {
  seasonNames: string[] | undefined;
  dateRanges: DateRangeDto[] | undefined;
  otherChips: Record<string, string | string[] | undefined>;
};

const SearchChips = ({ seasonNames, dateRanges, otherChips }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <div className='search-chips-container'>
        {seasonNames?.length ? (
          <GrouppedChip groupName={t('chip.season')} label={seasonNames} />
        ) : (
          dateRanges && (
            <>
              <GrouppedChip groupName={t('chip.from')} label={displayDate(dateRanges[0].utcDateFrom)} />
              <GrouppedChip groupName={t('chip.to')} label={displayDate(dateRanges[0].utcDateTo)} />
            </>
          )
        )}
        {Object.entries(otherChips ?? {}).map(
          ([key, value]) => value && <GrouppedChip key={key} groupName={t('chip.' + key)} label={value} />
        )}
      </div>
      <div style={{ padding: '0 16px' }}>
        <Divider />
      </div>
    </>
  );
};

export const GrouppedChip = ({ label, groupName }: { label: string | string[]; groupName?: string }) => {
  const chipLabel = Array.isArray(label) ? label.join(', ') : label;
  const labelsLength = Array.isArray(label) ? label.length : 1;

  return groupName ? (
    <Tooltip title={chipLabel} placement='bottom' arrow>
      <Chip label={`${labelsLength} ${groupName}`} color='#007AFF' />
    </Tooltip>
  ) : (
    <Chip label={chipLabel} color='#007AFF' />
  );
};

export default SearchChips;
